import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { GetAllShowsResponse } from '../model/recital';

export interface GetAllShowsParams {
  recitalId: string;
  page?: number;
  limit?: number;
}

export const getAllShowsAPI = async ({
  recitalId,
  ...params
}: GetAllShowsParams) => {
  const response = await baseAPI.get<GetAllShowsResponse>(
    `/recitals/${recitalId}/shows`,
    {
      params,
    },
  );
  return response.data;
};

export const getAllShowsOptions = (params: GetAllShowsParams) => {
  return queryOptions({
    queryKey: [KEYS.RECITALS, params.recitalId, KEYS.SHOWS, params],
    queryFn: () => getAllShowsAPI(params),
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetAllShows = (params: GetAllShowsParams) => {
  return useQuery(getAllShowsOptions(params));
};
